import api from "../common/api";

const getAll = () => api.get("/slides");

const create = (data) => api.post("/slides", data);

const slidesService = { getAll, create };

export default slidesService;
